const routes = [
  {
    path: 'particlesjs',
    component: () => import(/* webpackChunkName: "particlesjs" */ '@/modules/particlesjs/index.vue'),
    children: [
      {
        path: '',
        name: 'particlesjs',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/particlesjs/demo1.vue'),
      },
      {
        path: 'demo1',
        name: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/particlesjs/demo1.vue'),
      },
      {
        path: 'demo2',
        name: 'demo2',
        component: () => import(/* webpackChunkName: "demo2" */ '@/modules/particlesjs/demo2.vue'),
      },
    ],
  },
];

export default routes;